<script>
import ImageMixin from '@src/mixins/imageMixin.js'

export default {
  props: {
    info: {
      type: Object
    },
  },
  mixins: [
    ImageMixin
  ],
}
</script>

<template>
  <a :href="info.route" class="link">
    <div class="card" :style="getBackground(info.image[0])">
      <div class="card-footer">
        <p class="title" v-html="info.title">
        </p>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
@import '@design';

.card {
  height: 200px;
  width: 270px;
  display: flex;
  align-items: flex-end;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: cover;

  &:hover {
    transition: background-size 0.2s ease-out !important;
    background-size: 120% !important;
  }
}

.card-footer {
  height: 60px;
  width: 270px;
  background: $gray;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 23px;
}

.title {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: $white;
  text-transform: uppercase;
  text-align: center;
}

.link {
  text-decoration: none;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .card {
    height: 230px;
    width: 100%;
  }

  .card-footer {
    width: 100%;
  }
}
</style>
